/**
 * Labstep
 *
 * @module components/Filter/User
 * @desc User SearchSelect filter
 */

import UserSearchSelect from 'labstep-web/components/User/SearchSelect';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { User } from 'labstep-web/models/user.model';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import type { FilterUserProps } from './types';
import { onUserChange } from './utils';

export const FilterUser: React.FC<FilterUserProps> = ({
  setParams,
  icon,
  header,
  type,
  addPostFilter,
}: FilterUserProps) => (
  <Modal
    header={header}
    content={({ toggleModal }): React.ReactElement => (
      <UserSearchSelect
        onChange={(selectedOption): void => {
          onUserChange(
            selectedOption,
            type,
            setParams,
            addPostFilter,
          );
          toggleModal();
        }}
        placeholder={`Select ${getHumanReadableEntityName(
          User.entityName,
          true,
        )} from the list below`}
      />
    )}
    viewComponent={({ toggleModal }): React.ReactElement => (
      <ActionComponent
        type="option"
        icon={icon}
        text={header}
        onClick={toggleModal}
      />
    )}
  />
);
